import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { TranslateModule } from "@ngx-translate/core";

import { SelectComponent } from "./select.component";

const DIRECTIVES: any[] = [SelectComponent];

@NgModule({
	imports: [CommonModule, MatFormFieldModule, TranslateModule, MatSelectModule, MatInputModule, ReactiveFormsModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class SelectModule {}
